module.exports = __webpack_public_path__ + "../resources/images/headshot-robin-hd-a3bae2368d9215bc68b421aaf1c0828f.jpg";